import { render, staticRenderFns } from "./InspectionCriteria2.vue?vue&type=template&id=cb435078&scoped=true"
import script from "./InspectionCriteria2.vue?vue&type=script&lang=ts"
export * from "./InspectionCriteria2.vue?vue&type=script&lang=ts"
import style0 from "./InspectionCriteria2.vue?vue&type=style&index=0&id=cb435078&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb435078",
  null
  
)

export default component.exports